import { render, staticRenderFns } from "./PlacementCard.vue?vue&type=template&id=6ecf7ba2&scoped=true&"
import script from "./PlacementCard.vue?vue&type=script&lang=js&"
export * from "./PlacementCard.vue?vue&type=script&lang=js&"
import style0 from "./PlacementCard.vue?vue&type=style&index=0&id=6ecf7ba2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecf7ba2",
  null
  
)

export default component.exports